var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15181 0.591004C6.57002 0.349548 7.08528 0.349548 7.50349 0.591004L12.8281 3.66516C13.2463 3.90662 13.5039 4.35284 13.5039 4.83576V10.9841C13.5039 11.467 13.2463 11.9132 12.8281 12.1547L7.50349 15.2288C7.08528 15.4703 6.57002 15.4703 6.15181 15.2288L0.82721 12.1547C0.408997 11.9132 0.151367 11.467 0.151367 10.9841V4.83576C0.151367 4.35284 0.408997 3.90662 0.82721 3.66516L6.15181 0.591004ZM6.82765 1.7616L11.4739 4.44413L6.80211 7.12909L2.15588 4.45884L6.82765 1.7616ZM1.50305 10.9841V5.64266L6.1264 8.29976V13.6534L1.50305 10.9841ZM7.47808 13.6827L12.1522 10.9841V5.61331L7.47808 8.29961V13.6827Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/Sessions.6d700a0755b615ae677ca2ef8bfaf289.svg";
export { ForwardRef as ReactComponent };